import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { PartialUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';
import { NbaTargetTypes } from '~/app/tracking/feld-m-types';

export const local: PartialCarConfiguration = {
	combinations: [
		'trimLine',
		'packages',
		'equipmentPackages',
		'paint',
		'rims',
		'headlights',
		'interior',
		'steeringWheels',
	],
	hasJetStream: true,
	showEECLabel: true,
	showCaESummaryText: true,
	engineCardKeyfacts: [
		'electricRanges',
		'acceleration',
		'speed',
		'consumption',
		'consumptionPHEVCombustion',
		'consumptionPHEV',
		'emissionCO2',
		'emissionCO2PHEV',
		'consumptionPHEVEmptyBattery',
		'classCO2',
		'classCO2Sustaining',
	],
	financeDomain: 'AUDI.NEW.SKA',
	financingDisclaimer: ['calculationDisclaimer', 'productDisclaimer'],
	showFinancingDisclaimerInDialogs: true,
	wltpLink: '',
	wltpInfo: {
		url: {
			url: '',
			pathParams: {},
			queryParams: [],
		},
	},
	enableIncentives: true,
	nextBestActions: [
		{
			icon: 'wallbox',
			description: 'Audi Wallbox kaufen',
			labelText: 'Audi Wallbox',
			trackingName: NbaTargetTypes.BuyWallbox,
			url: 'https://audi.elli.eco/de-DE/shop/configurator',
			target: '_blank',
		},
		{
			icon: 'send',
			description: 'Verkaufsberater kontaktieren',
			labelText: 'Verkaufsberater kontaktieren',
			trackingName: NbaTargetTypes.Contact,
			url: 'https://api.my.audi.de/form/v1/forms/brandportalfd/salesperson-de-de?apiKey=brandportal-html&embedded=false&src=conf&vmt={{carline}}&vmn={{trimline}}&vac={{audiCode}}&vcl={{carlineId}}&vft={{financeProd}}&vmy={{modelYear}}&vc=EUR&pcl=https%3A%2F%2Fwww.audi.de%3D{{audiCode}}',
			target: '_blank',
		},
		{
			icon: 'test-drive',
			description: 'Probefahrt vereinbaren',
			labelText: 'Probefahrt vereinbaren',
			trackingName: NbaTargetTypes.TestDrive,
			url: 'https://api.my.audi.de/form/v1/forms/brandportalfdv2/testdriveconf-de-de?apiKey=brandportal-html&embedded=false&src=conf&vmt={{carline}}&vmn={{trimline}}&vac={{audiCode}}&vcl={{carlineId}}&vft={{financeProd}}&vmy={{modelYear}}&vc=EUR&pcl=https%3A%2F%2Fwww.audi.de%3D{{audiCode}}',
			target: '_blank',
		},
	],
	summaryFooterCta: {
		icon: 'send',
		description: 'Verkaufsberater kontaktieren',
		labelText: 'Verkaufsberater kontaktieren',
		trackingName: NbaTargetTypes.Contact,
		url: 'https://api.my.audi.de/form/v1/forms/brandportalfd/salesperson-de-de?apiKey=brandportal-html&embedded=false&src=conf&vmt={{carline}}&vmn={{trimline}}&vac={{audiCode}}&vcl={{carlineId}}&vft={{financeProd}}&vmy={{modelYear}}&vc=EUR&pcl=https%3A%2F%2Fwww.audi.de%3D{{audiCode}}',
		target: '_blank',
	},
	showEfficiencyClass: true,
};

export const local_ui: PartialUiConfiguration = {
	showAccessoriesExclusive: true,
	showAccessoriesInclusive: true,
};
